<template>
  <div v-show="show" class="add-page">
    <div class="router">
      <div class="back">
        <a-icon @click="$emit('close')" type="left"></a-icon>
        <div @click="$emit('close')" style="flex: 1;" class="name">返回</div>

        <a-space>
          <a-button @click="$emit('close')" size="small" shape="round"
            >取消</a-button
          >
          <a-button
            @click="handleConfirm"
            size="small"
            shape="round"
            type="primary"
            >完成</a-button
          >
        </a-space>
      </div>
    </div>

    <div v-if="currentStudent" class="content-box">
      <div class="students">
        <div class="name">学生名单</div>
        <ul>
          <li
            v-for="(item, index) in data.students"
            :key="index"
            :class="{
              active: currentStudent && currentStudent.name == item.name,
            }"
            @click="changeStudent(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="level">
        <div v-if="currentStudent" style="width: 100%;" class="title flex-row">
          <div style="flex: 1;">记录 {{ currentStudent.name }} 的发展阶段</div>
          <a-checkbox style="margin-left: auto;" v-model="allChecked"
            >应用于全部名单</a-checkbox
          >
        </div>
        <div class="range flex-row">
          {{ data && data.range }}
        </div>
        <div class="mubiao">
          {{ data && data.detail.name }}
        </div>

        <div
          v-if="currentStudent && currentStudent.bea"
          v-for="(item, index) in currentStudent.bea.childs"
          :key="index"
          class="level-list"
        >
          <a-divider orientation="left">
            {{ item.name }}
          </a-divider>
          <ul>
            <li v-for="(child, index) in item.childs" :key="index">
              <a-checkbox
                class="label"
                :checked="child.checked"
                @change="handleCheck(child)"
                :name="child.id"
                :value="child.id"
              >
                {{ child.name }}
              </a-checkbox>
              <a-popover
                style="flex-shrink: 0;margin-left: 10px;"
                placement="right"
                trigger="click"
              >
                <div class="look">
                  查看案列
                </div>
                <template slot="content">
                  <div
                    v-for="(item, index) in child.childs"
                    :key="index"
                    class="example"
                  >
                    {{ index + 1 + "、" + item.name }}
                  </div>
                </template>
              </a-popover>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  data() {
    return {
      currentStudent: null,
      allChecked: false,
    };
  },
  props: {
    beaStudents: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  filters: {
    exampleFilter(data) {
      return data.map((item) => item.name).join("<br/>");
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.currentStudent = this.data.students[0];
      }
    },
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  methods: {
    handleCheck(child) {
      child.checked = !child.checked;
      //强制刷新vue
      this.$forceUpdate();
    },
    changeStudent(item) {
      console.log(item);
      this.currentStudent = item;
    },
    handleConfirm() {
      console.log(this.allChecked);
      let list = [];
      if (this.allChecked) {
        this.data.students.forEach((element) => {
          const student = {
            name: element.name,
            id: element.id,
            class_name: element.class_name,
            sex: element.sex,
            targets: [],
          };
          this.currentStudent.bea.childs.forEach((ele) => {
            ele.childs.forEach((element2, index) => {
              if (element2.checked) {
                const level = {
                  field_name: this.data.range.split(">")[0],
                  field2_name: this.data.range.split(">")[1],
                  field3_name: this.data.detail.name,
                  id: this.data.rangeId,
                  targets: [element2],
                };

                if (student.targets.map((item) => item.id).includes(level.id)) {
                  student.targets
                    .find((item) => item.id === level.id)
                    .targets.push(element2);
                } else {
                  student.targets.push(level);
                }
              }
            });
          });
          if (student.targets.length) {
            list.push(student);
          }
        });
      } else {
        this.data.students.forEach((element) => {
          const student = {
            name: element.name,
            id: element.id,
            class_name: element.class_name,
            sex: element.sex,
            targets: [],
          };
          element.bea.childs.forEach((ele) => {
            ele.childs.forEach((element2, index) => {
              if (element2.checked) {
                const level = {
                  field_name: this.data.range.split(">")[0],
                  field2_name: this.data.range.split(">")[1],
                  field3_name: this.data.detail.name,
                  id: this.data.rangeId,
                  targets: [element2],
                };

                if (student.targets.map((item) => item.id).includes(level.id)) {
                  student.targets
                    .find((item) => item.id === level.id)
                    .targets.push(element2);
                } else {
                  student.targets.push(level);
                }
              }
            });
          });
          if (student.targets.length) {
            list.push(student);
          }
        });
      }

      // if (list.length < this.data.students.length) {
      //   this.$message.error("选择指标与学生人数不匹配");
      //   return;
      // }

      this.$message.success("添加成功");
      setTimeout(() => {
        this.currentStudent = null;
        this.$emit("add", list);
      }, 600);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-page {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  height: 100%;
  background: #f1f8fd;
  max-width: 910px;
  margin: 0 auto;

  .router {
    display: flex;
    margin-left: 210px;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    flex-direction: row;
    padding: 0 0px;
    color: #999;
    .back {
      display: flex;
      align-items: center;
      cursor: pointer;
      width: 100%;
      flex-direction: row;
      .name {
        margin-left: 5px;
        color: #999;
      }
    }
  }
}

.content-box {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
  gap: 30px;

  .students {
    width: 180px;
    background: #fff;
    padding: 15px 5px;
    margin-right: 30xp;
    max-height: calc(100% - 80px);
    overflow-y: auto;
    border-radius: 5px;

    .name {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 10px;
      margin-left: 14px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 15px;
        margin: 5px 0;
        width: 100%;
        user-select: none;
        cursor: pointer;

        &.active {
          background: #71a2ce;
          color: #fff;
          border-radius: 5px;
        }
      }
    }
  }

  .level {
    flex: 1;
    flex-shrink: 0;
    background: #fff;
    max-height: calc(100% - 80px);
    overflow-y: scroll;
    border-radius: 5px;
    padding: 15px;

    .title {
      border-bottom: 1px solid #eee;
      font-size: 16px;
      font-weight: bold;
      padding: 12px 0 22px 0;
    }

    .range {
      justify-content: flex-start;
      margin: 5px 0;
    }

    .mubiao {
      font-weight: bold;
      font-size: 16px;
      color: #71a2ce;
    }

    .level-list {
      user-select: none;
      ::selection {
        background: transparent;
      }
      width: 100%;
      .look {
        user-select: none;
      }
      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 1px solid #eee;
          box-shadow: 0 0 3px 2px rgba($color: #000000, $alpha: 0.08);
          padding: 10px 15px;
          line-height: 2.6;
          margin: 10px 0;
          border-radius: 10px;
          cursor: pointer;

          .look {
            color: #71a2ce;
          }
        }
      }
    }
  }
}

.example {
  max-width: 140px;
  text-align: justify;
  user-select: none;
}
</style>

<style>
.ant-popover {
  user-select: none;
}

.example {
  word-break: break-all;
  white-space: pre-wrap;
}
</style>
